import React from 'react';
import styles from './loader.module.scss';

interface ILoaderProps {
    message?: string;
    size?: 'small' | 'medium' | 'large';
    overlay?: boolean;
}

const Loader: React.FC<ILoaderProps> = (props) => {
    const {
        message = 'Loading...',
        size = 'medium',
        overlay = true
    } = props;

    return (
        <div className={`${styles.loaderContainer} ${overlay ? styles.loaderOverlay : ''}`}>
            <div className={styles.loaderContent}>
                <div className={`${styles.spinner} ${styles[size]}`}>
                    <div className={styles.spinnerCircle}></div>
                    <div className={styles.spinnerCircle}></div>
                    <div className={styles.spinnerCircle}></div>
                </div>
                {message && <p className={styles.loaderMessage}>{message}</p>}
            </div>
        </div>
    );
};

export default Loader;
